<template>
  <div
    class="customer-detail-page c:col-center-stretch"
    v-if="data?.customerExternalUserid"
  >
    <CustomerDetailHeader :data="data" />
    <HDivider />
    <div class="customer-detail-tabview">
      <TabView
        :tabs="tabs"
        tab-height="40"
        tabbar-text-color="#7d7d7d"
        tabbar-rail-color="#e4e4e4"
      >
        <template #info>
          <div class="customer-info">
            <!-- <InfoTile label="初次添加销售时间">{{
            data. | formatDateTime
          }}</InfoTile> -->
            <!-- <InfoTile label="初次添加销售顾问">张凯文</InfoTile> -->
            <InfoTile label="最后购买时间">{{
              data.lastOrderTime | formatDateTime
            }}</InfoTile>
            <InfoTile label="最后购买销售顾问">{{
              data.lastSalesCaName
            }}</InfoTile>
            <!-- <InfoTile label="地区信息">中国 上海 徐汇</InfoTile> -->
          </div>
        </template>
        <template #orders>
          <div class="order-list">
            <van-list
              v-model="orderLoading"
              :finished="orderLoadFinished"
              :finished-text="orderFinishedText"
              @load="loadOrders"
            >
              <order-list-cell
                :data="item"
                v-for="(item, index) in orderList"
                :key="index"
              />
            </van-list>
            <CBottomPad />
          </div>
        </template>
        <!-- <template #salers>
          <div class="saler-list">
            <van-list
              v-model="salerLoading"
              :finished="salerLoadFinished"
              finished-text=""
              @load="loadSalers"
            >
              <saler-list-cell
                v-for="(item, index) in salerList"
                :key="index"
                :data="item"
              />
            </van-list>
            <CBottomPad />
          </div>
        </template> -->
      </TabView>
    </div>
  </div>
</template>

<script>
import { getCustomerDetail, getEmployeeList, getOrderList } from "@/api";
import CBottomPad from "@/components/common/CBottomPad.vue";
import HDivider from "@/components/common/HDivider.vue";
import InfoTile from "@/components/common/InfoTile.vue";
import TabView from "@/components/common/TabView.vue";
import CustomerDetailHeader from "@/components/customer/CustomerDetailHeader.vue";
import OrderListCell from "@/components/order-list/OrderListCell.vue";
// import SalerListCell from "@/components/saler-list/SalerListCell.vue";
import normalPage from "@/mixins/normal-page";
import { mapState } from "vuex";

export default {
  mixins: [normalPage],
  components: {
    HDivider,
    CustomerDetailHeader,
    TabView,
    InfoTile,
    OrderListCell,
    // SalerListCell,
    CBottomPad,
  },
  data() {
    return {
      tabs: [
        {
          key: "info",
          label: "个人资料",
        },
        {
          key: "orders",
          label: "订单信息",
        },
        // {
        //   key: "salers",
        //   label: "所有销售",
        // },
      ],
      data: {},
      orderLoading: false,
      orderLoadFinished: false,
      orderFinishedText: "",
      orderPage: 1,
      orderList: [],
      salerLoading: false,
      salerLoadFinished: false,
      salerList: [],
    };
  },
  computed: {
    ...mapState(["customerDetail"]),
    customerExternalUserid() {
      return this.$route.query.id;
    },
  },
  mounted() {
    console.log("mounted", this.customerDetail, this.customerExternalUserid);
    if (
      this.customerDetail.customerExternalUserid ===
      +this.customerExternalUserid
    ) {
      this.data = this.customerDetail;
    } else {
      this.loadData();
    }
  },
  methods: {
    async loadData() {
      try {
        this.$toast.loading({
          message: "加载中",
          forbidClick: true,
        });
        const [res] = await Promise.all([
          getCustomerDetail(this.customerExternalUserid),
          this.loadOrders(),
          // this.loadSalers(),
        ]);
        this.data = res;
        this.$toast.clear();
      } catch (error) {
        if (error?.message) this.$toast(error.message);
        else this.$toast.clear();
      }
    },
    async loadOrders() {
      if (this.orderLoading) return;
      try {
        const res = await getOrderList({
          customerExternalUseridList: [this.customerExternalUserid],
          pageNum: this.orderPage || 1,
          pageSize: 10,
        });
        console.log("getOrderList", res);
        res.data?.forEach((element) => {
          this.orderList.push(element);
        });
        this.orderPage++;
        this.orderLoading = false;
        if (res.hasMore) {
          this.orderLoadFinished = false;
        } else {
          this.orderLoadFinished = true;
          this.orderFinishedText = "已加载全部订单";
        }
      } catch (error) {
        this.orderLoading = false;
        this.orderLoadFinished = true;
        this.orderFinishedText = "加载订单出错";
        if (error?.message) this.$toast(error.message);
      }
    },
    async loadSalers() {
      if (this.salerLoading) return;
      try {
        this.salerList = [];
        const res = await getEmployeeList({
          customerExternalUserid: this.customerExternalUserid,
        });
        console.log("getEmployeeList", res);
        this.salerList = res;
      } catch (error) {
        console.log("getSalers error", error);
        if (error?.message) this.$toast(error.message);
      } finally {
        this.salerLoading = false;
        this.salerLoadFinished = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.customer-detail-page {
  width: 100%;
  height: 100%;

  .customer-detail-tabview {
    flex: 1;
    width: 100%;
    // height: 0;
  }

  .order-list {
    width: 100%;
    height: 100%;
    padding-top: 4/20rem;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .saler-list {
    width: 100%;
    height: 100%;

    padding-bottom: 10/20rem;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
